import { Injectable } from '@angular/core';
import config from '../../config/config.json';

/** Config key for AI Workbench (embedded iframe in agent workspace). */
const WORKBENCH_ACCESS_CONFIG = (config as { WorkbenchAccess?: { privilege?: string } }).WorkbenchAccess;

/**
 * URF privilege required to use AI Workbench when the tenant enables `workbench_access` in app-config.
 * Read from config.json WorkbenchAccess.privilege, fallback  to empty string ``.
 */
export const WORKBENCH_ACCESS_PRIVILEGE = WORKBENCH_ACCESS_CONFIG?.privilege ?? '';

/**
 * Service to determine whether the user has access to the AI Workbench.
 */
@Injectable({
  providedIn: 'root'
})
export class WorkbenchAccessService {
  private privilegeNames: string[] = [];

  /**
   * Set privilege names (e.g. from {@link AgentAccessControlService.getUserPrivileges} when loading v3.0).
   */
  setPrivileges(privilegeNames: string[]): void {
    this.privilegeNames = Array.isArray(privilegeNames) ? privilegeNames : [];
  }

  /**
   * True when the user has the configured workbench privilege.
   */
  hasWorkbenchAccess(): boolean {
    return this.privilegeNames.includes(WORKBENCH_ACCESS_PRIVILEGE);
  }
}
